import { render, staticRenderFns } from "./left_2.vue?vue&type=template&id=9c363970&scoped=true&"
import script from "./left_2.vue?vue&type=script&lang=js&"
export * from "./left_2.vue?vue&type=script&lang=js&"
import style0 from "./left_2.vue?vue&type=style&index=0&id=9c363970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c363970",
  null
  
)

export default component.exports